import { RootReducer } from '../rootReducer';

export const selectIsOpenSidebar = (state: RootReducer) => state.ui.isOpenSidebar;
